module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu_1@2x.bcc50459.jpg";